module.exports = __webpack_public_path__ + "static/media/asada-shino-icon.8d6687d3.png";